import { Divider, Stack, Typography } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { KeyValue } from '@/components/shared/key-value';
import {
  courseTypesLabels,
  modalityTypesLabels,
} from '@/constants/catalog/course';
import { periodTypesLabels } from '@/constants/catalog/offer';
import { EligibleResourceType } from '@/data/subsidy/policies/interfaces';
import { PriceTypes } from '@/models/catalog/course';
import type { DetailsProps } from '@/packages/subsidy-management/interfaces';
import { formatMoney } from '@/utils/format-money';
import { formatDuration } from '@/utils/masks/time';

export const DescriptionContent = ({
  resourceApprovalsDetails,
}: DetailsProps) => {
  const course = resourceApprovalsDetails?.resource?.course;

  return (
    <Stack gap={2}>
      <KeyValue
        label="Política"
        value={resourceApprovalsDetails?.policies?.[0].name}
      />
      <KeyValue
        label="Catálogo"
        value={
          resourceApprovalsDetails?.resource?.course?.source ===
          EligibleResourceType.Catalog
            ? 'Plataforma Galena'
            : 'Fora da Galena'
        }
      />
      <KeyValue
        label="Tipo de item"
        value={resourceApprovalsDetails?.policies?.[0].name}
      />
      {course?.institution_name && (
        <KeyValue label="Instituição" value={course?.institution_name || ''} />
      )}
      <KeyValue label="Curso" value={resourceApprovalsDetails?.name || ''} />
      {course?.course_type && (
        <KeyValue
          label="Categoria"
          value={courseTypesLabels[course?.course_type] || ''}
        />
      )}
      {course?.modality && (
        <KeyValue
          label="Modalidade"
          value={modalityTypesLabels[course?.modality]}
        />
      )}
      {course?.period && (
        <KeyValue label="Turno" value={periodTypesLabels[course?.period]} />
      )}
      {course?.workload && (
        <KeyValue label="Carga horária" value={course?.workload} />
      )}
      {course?.duration_type && (
        <KeyValue
          label="Duração"
          value={formatDuration(course?.duration_type, course?.duration)}
        />
      )}
      <KeyValue
        label="Tipo de pagamento"
        value={
          resourceApprovalsDetails?.sale_type === PriceTypes.OneOff
            ? 'Único'
            : 'Mensal'
        }
      />
      <KeyValue
        label="Valor"
        value={formatMoney(resourceApprovalsDetails?.sale_price || '')}
      />
      {resourceApprovalsDetails?.request_reason && (
        <KeyValue
          label="Justificativa"
          value={resourceApprovalsDetails?.request_reason || ''}
        />
      )}
      <Divider sx={{ my: 1 }} />
      <Stack direction={{ md: 'row' }} justifyContent="space-between">
        <Typography fontWeight={fontWeights.fontWeightSemibold}>
          Custo total do item
        </Typography>
        <Typography>
          {formatMoney(resourceApprovalsDetails?.sale_price || '')}
        </Typography>
      </Stack>
      <Stack direction={{ md: 'row' }} justifyContent="space-between">
        <Typography fontWeight={fontWeights.fontWeightSemibold}>
          Valor máximo reembolsável
        </Typography>
        <Typography>
          {formatMoney(
            resourceApprovalsDetails?.requested_refundable_amount || ''
          )}
        </Typography>
      </Stack>
      <Typography>
        Calculado de acordo com as regras de reembolso da sua política. O
        reembolso final depende também do seu saldo disponível.
      </Typography>
    </Stack>
  );
};
